import { useNavigate, useParams } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import { Heading, Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";
import { SectionCard } from "../../../../components/common/section-card/section-card";
import { ShimmerLoader, Shimmer } from "../../../../components/common/shimmer/shimmer";
import { LoyaltyPromotionForm } from "../components/loyalty-promotion-form";
import { useLoyaltyPromotions } from "../../hooks/useLoyaltyPromotions";
import { AppRoutes } from "../../../../common/routes/app_routes";

/** Full-page create / edit form for a loyalty promotion (replaces the dialog). */
export function AdminLoyaltyPromotionEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  // Edit reuses the list (already cached from the promotions page) to find the row.
  const { data: promotions, isLoading } = useLoyaltyPromotions();
  const promotion = isEdit ? promotions?.find((p) => p.id === id) : undefined;

  const back = () => navigate(AppRoutes.ADMIN_LOYALTY_PROMOTIONS);
  const title = isEdit ? "Edit promotion" : "New promotion";

  return (
    <div className="flex min-h-full w-full flex-col bg-bgLight">
      <div className="flex flex-1 flex-col gap-4 px-8 pt-6 pb-6">
        <div className="flex items-center gap-2">
          <Button
            variant="ghostAccent"
            size="sm"
            leftIcon={<IconArrowLeft size={18} />}
            onClick={back}
            className="!h-auto !px-0 !py-0"
          >
            <Heading variant="h3" tone="inherit">Promotions</Heading>
          </Button>
          <Text variant="bodySm" tone="muted">/</Text>
          <Heading variant="h3" tone="dark">{title}</Heading>
        </div>

        <SectionCard shadow title="Promotion details" className="max-w-3xl gap-5">
          {isEdit && isLoading ? (
            <ShimmerLoader message="Loading promotion…">
              <Shimmer className="h-96 rounded-xl" />
            </ShimmerLoader>
          ) : isEdit && !promotion ? (
            <Text variant="body" tone="muted">Promotion not found.</Text>
          ) : (
            <LoyaltyPromotionForm promotion={promotion} onSaved={back} onCancel={back} />
          )}
        </SectionCard>
      </div>
    </div>
  );
}
